
const { ifExist } = await import(/* webpackChunkName: "utility" */ 'Common/Scripts/Common/utility');


// styles
import(/* webpackChunkName: "page" */ '../Styles/Partials/page.scss');

import(/* webpackChunkName: "counterPayAndPlay" */ '../Styles/Partials/counterPayAndPlay.scss');

import(/* webpackChunkName: "linklist" */ '../Styles/Partials/linklist.scss');

import(/* webpackChunkName: "formsLottery" */ '../Styles/Partials/formsLottery.scss');

import(/* webpackChunkName: "richTextLottery" */ '../Styles/Partials/richTextLottery.scss');

import(/* webpackChunkName: "lotteryStage-footnote" */ 'Feature/LotteryContentElements/code/Styles/LotteryStage/lotteryStage-footnote.scss');


//  on-demand styles

//if (ifExist('.designcard-overview')) import(/* webpackChunkName: "lotteryDesignCardOverview" */ 'Feature/LotteryContentElements/code/Styles/DesignCard/lotteryDesignCardOverview.scss');

if (ifExist('.trust-element')) import(/* webpackChunkName: "trustElement" */ 'Feature/LotteryContentElements/code/Styles/TrustElement/trustElement.scss');

if (ifExist('.icon-text-module')) import(/* webpackChunkName: "iconTextModule" */ 'Feature/LotteryContentElements/code/Styles/IconTextModule/iconTextModule.scss');

if (ifExist('.imageFloatingTextTeaser-container')) import(/* webpackChunkName: "imageFloatingText" */ 'Feature/ContentElements/code/Styles/TeaserImageText/imageFloatingText.scss');

if (ifExist('.lottery-participationcheck')) import(/* webpackChunkName: "lotteryParticipationCheck" */ 'Feature/LotteryParticipationCheck/code/Styles/lotteryParticipationCheck.scss');

if (ifExist('.footnotes-container')) import(/* webpackChunkName: "footnotes" */ 'Feature/ContentElements/code/Styles/Footnotes/footnotes.scss');

if (ifExist('.icontextmodule')) import(/* webpackChunkName: "iconTextModuleSpecialRaffle" */ 'Feature/ContentElements/code/Styles/IconTextModuleSpecialRaffle/iconTextModuleSpecialRaffle.scss');

if (ifExist('.lottery-page')) import(/* webpackChunkName: "feedback-widget" */ 'Feature/Common/code/Styles/feedback-widget.scss');

if (ifExist('.lottery-page')) import(/* webpackChunkName: "webchat-widget" */ 'Feature/Common/code/Styles/webchat-widget.scss');

if (ifExist('.lottery-winning-chances__purchase-teaser')) import(/* webpackChunkName: "lotteryWinningChancesPurchaseTeaser" */ 'Feature/LotteryContentElements/code/Styles/LotteryWinningChances/lotteryWinningChancesPurchaseTeaser.scss');

if (ifExist('.lottery-winning-chances__features-block')) import(/* webpackChunkName: "lotteryWinningChancesFeaturesBlock" */ 'Feature/LotteryContentElements/code/Styles/LotteryWinningChances/lotteryWinningChancesFeaturesBlock.scss');

if (ifExist('.lottery-winning-chances__chance-comparison-block')) import(/* webpackChunkName: "lotteryWinningChancesComparisonBlock" */ 'Feature/LotteryContentElements/code/Styles/LotteryWinningChances/lotteryWinningChancesComparisonBlock.scss');

if (ifExist('.lottery-winning-chances__winners-block')) import(/* webpackChunkName: "lotteryWinningChancesWinnerBlock" */ 'Feature/LotteryContentElements/code/Styles/LotteryWinningChances/lotteryWinningChancesWinnerBlock.scss');

if (ifExist('.sr-phase3')) import(/* webpackChunkName: "phase3SpecialRaffle" */ 'Feature/ContentElements/code/Styles/SpecialRaffle/phase3SpecialRaffle.scss');

if (ifExist('.ical-button-module')) import(/* webpackChunkName: "iCalButtonSpecialRaffle" */ 'Feature/ContentElements/code/Styles/SpecialRaffle/iCalButtonSpecialRaffle.scss');

if (ifExist('.lottery-blue-sectIcon-text-teaser')) import(/* webpackChunkName: "LotteryBlueSectIconTextTeaser" */ 'Feature/LotteryContentElements/code/Styles/LotteryBlueSectIconTextTeaser/LotteryBlueSectIconTextTeaser.scss');

if (ifExist('.teaser-5050-with-background-color')) import(/* webpackChunkName: "teaser5050WithColor" */ 'Feature/LotteryPayAndPlay/code/Styles/teaser5050WithColor.scss');

if (ifExist('.wrong-lotnumber-info-box')) import(/* webpackChunkName: "wrongLotNumberInfoBox" */ 'Feature/LotteryPayAndPlay/code/Styles/wrongLotNumberInfoBox.scss');

if (ifExist('.numbers-and-drawings')) import(/* webpackChunkName: "payandplay" */ 'Feature/LotteryPayAndPlay/code/Styles/payandplay.scss');

if (ifExist('.cancellation-prevention__thanks')) import(/* webpackChunkName: "cancelLotteryNumberInput" */ 'Feature/LotteryCancellationPrevention/code/Styles/cancelLotteryNumberInput.scss');

if (ifExist('.vue-application-wrapper')) import(/* webpackChunkName: "shop" */ 'Feature/Shop/code/Styles/shop.scss');

if (ifExist('.shop-lottery-appteaser')) import(/* webpackChunkName: "shopLotAppTeaser" */ 'Feature/Shop/code/Styles/shopLotAppTeaser.scss');

if (ifExist('.shop-lot-pdfdownload')) import(/* webpackChunkName: "shopLotPdfDownload" */ 'Feature/Shop/code/Styles/shopLotPdfDownload.scss');

if (ifExist('.faq-overview-container')) import(/* webpackChunkName: "faq" */ 'Feature/LotteryContentElements/code/Styles/Faq/faq.scss');

// scripts

import(/* webpackChunkName: "ticket" */ 'Foundation/Common/code/Scripts/Ticket/ticket');

//  on-demand scripts

if (ifExist('[data-image-zoom]:not([data-image-zoom=""])')) import(/* webpackChunkName: "imageZoom" */ 'Foundation/ImageZoom/code/Scripts/imageZoom');

if (ifExist('.designcard-overview')) import(/* webpackChunkName: "designCardOverview" */ 'Feature/LotteryContentElements/code/Scripts/DesignCard/designCardOverview');

if (ifExist('.footer')) import(/* webpackChunkName: "footerLottery" */ 'Feature/LotteryNavigation/code/Scripts/footerLottery.cmp');

if (ifExist('.sticky-footer')) import(/* webpackChunkName: "lotteryStickyFooter" */ 'Feature/LotteryContentElements/code/Scripts/LotteryStickyFooter/lotteryStickyFooter.js');

if (ifExist('.lottery-header')) import(/* webpackChunkName: "headerLottery" */ 'Feature/LotteryNavigation/code/Scripts/headerLottery');

if (ifExist('.metanav_lottery')) import(/* webpackChunkName: "loginLottery" */ 'Feature/LotteryNavigation/code/Scripts/loginLottery');

if (ifExist('.lottery-payandplay')) import(/* webpackChunkName: "lotteryPayAndPlay" */ 'Feature/LotteryPayAndPlay/code/Scripts/lotteryPayAndPlay');

if (ifExist('.lottery-number-input')) import(/* webpackChunkName: "lotteryNumberInput" */ 'Feature/LotteryPayAndPlay/code/Scripts/lotteryNumberInput')

if (ifExist('.cancellottery-number-input, .cancellation-prevention')) import(/* webpackChunkName: "cancelLotteryNumberInput" */ 'Feature/LotteryCancellationPrevention/code/Scripts/cancelLotteryNumberInput')

if (ifExist('.cancellation-prevention__steptwo')) import(/* webpackChunkName: "cancelStepTwo" */ 'Feature/LotteryCancellationPrevention/code/Scripts/cancelStepTwo')

if (ifExist('.cancellation-prevention__stepthree')) import(/* webpackChunkName: "cancelStepThree" */ 'Feature/LotteryCancellationPrevention/code/Scripts/cancelStepThree')

if (ifExist('.counter-next-drawing')) import(/* webpackChunkName: "counterDrawingNext" */ 'Feature/LotteryPayAndPlay/code/Scripts/counterDrawingNext');

if (ifExist('.win-info-box')) import(/* webpackChunkName: "winInfoBox" */ 'Feature/LotteryPayAndPlay/code/Scripts/winInfoBox');

if (ifExist('.last-winnings-slider')) import(/* webpackChunkName: "lastWinningsSlider" */ 'Feature/LotteryPayAndPlay/code/Scripts/lastWinningsSlider');

if (ifExist('.lottery-type-draw-history')) import(/* webpackChunkName: "lotteryTypeDrawHistory" */ 'Feature/LotteryPayAndPlay/code/Scripts/lotteryTypeDrawHistory');

if (ifExist('.winning-numbers')) import(/* webpackChunkName: "winningNumbers" */ 'Feature/LotteryPayAndPlay/code/Scripts/winningNumbers');

if (ifExist('.previous-draw')) import(/* webpackChunkName: "previousDraw" */ 'Feature/LotteryPayAndPlay/code/Scripts/previousDraw');

if (ifExist('.no-win-info')) import(/* webpackChunkName: "noWin" */ 'Feature/LotteryPayAndPlay/code/Scripts/noWin');

if (ifExist('.whats-next-slider')) import(/* webpackChunkName: "whatIsNextSlider" */ 'Feature/LotteryPayAndPlay/code/Scripts/whatIsNextSlider');

if (ifExist('.what-your-lot-type')) import(/* webpackChunkName: "whatYourLotWin" */ 'Feature/LotteryPayAndPlay/code/Scripts/whatYourLotWin');

if (ifExist('.lottery-mainnav')) import(/* webpackChunkName: "desktopNavigationLottery" */ 'Feature/LotteryNavigation/code/Scripts/desktopNavigationLottery');

if (ifExist('.winning-plans')) import(/* webpackChunkName: "lotteryWinningPlans" */ 'Feature/LotteryContentElements/code/Scripts/LotteryWinningPlans/lotteryWinningPlans');

if (ifExist('.lottery-slider-text-teaser')) import(/* webpackChunkName: "lotterySliderTextTeaser" */ 'Feature/LotteryContentElements/code/Scripts/LotterySliderTextTeaser/lotterySliderTextTeaser.js');

if (ifExist('.lottery-nav-mobile-header')) import(/* webpackChunkName: "mobileNavigationLottery" */ 'Feature/LotteryNavigation/code/Scripts/mobileNavigationLottery');

if (ifExist('.heart-projects-slider')) import(/* webpackChunkName: "heartProjects" */ 'Feature/LotteryContentElements/code/Scripts/heartProjects');

if (ifExist('.projects-slider')) import(/* webpackChunkName: "projectSlider" */ 'Feature/LotteryContentElements/code/Scripts/projectSlider');

if (ifExist('.lottery-counter-animation')) import(/* webpackChunkName: "counterImageTeaser" */ 'Feature/LotteryContentElements/code/Scripts/counterImageTeaser');

if (ifExist('.lottery-counter-animation')) import(/* webpackChunkName: "counterSocialTeaser" */ 'Feature/LotteryContentElements/code/Scripts/counterSocialTeaser');

if (ifExist('.lottery-stage')) import(/* webpackChunkName: "lotteryStage" */ 'Feature/LotteryContentElements/code/Scripts/LotteryStage/lotteryStage');

if (ifExist('.lottery-stage-slider')) import(/* webpackChunkName: "lotteryStageSlider" */ 'Feature/LotteryContentElements/code/Scripts/LotteryStage/lotteryStageSlider');

if (ifExist('.sr-content-stage')) import(/* webpackChunkName: "contentStageSpecialRaffle" */ 'Feature/ContentElements/code/Scripts/SpecialRaffle/contentStageSpecialRaffle');

if (ifExist('.info-linklist')) import(/* webpackChunkName: "infoLinkList" */ 'Feature/ContentElements/code/Scripts/LinkList/infoLinkList');

if (ifExist('.lottery-ticket-upgrade-form')) import(/* webpackChunkName: "lotteryTicketUpgrade" */ 'Feature/LotteryTicketUpgrade/code/Scripts/lotteryTicketUpgrade');

if (ifExist('.lotconfigurator__change-winningcategory')) import(/* webpackChunkName: "lotConfigurator" */ 'Feature/ChangeWinningCategory/code/Scripts/lotConfigurator');

if (ifExist('.lottery-participationcheck')) import(/* webpackChunkName: "lotteryParticipationCheck" */ 'Feature/LotteryParticipationCheck/code/Scripts/lotteryParticipationCheck');

if (ifExist('.lottery-accordion__module')) import(/* webpackChunkName: "lotteryAccordion" */ 'Feature/LotteryContentElements/code/Scripts/LotteryAccordion/lotteryAccordion');

if (ifExist('.lottery-glossary__content')) import(/* webpackChunkName: "lotteryAccordionGlossar" */ 'Feature/LotteryContentElements/code/Scripts/LotteryAccordion/lotteryAccordionGlossar');

if (ifExist('.video-gallery')) import(/* webpackChunkName: "videoGallery" */ 'Feature/LotteryContentElements/code/Scripts/videoGallery');

if (ifExist('.contact-form')) import(/* webpackChunkName: "contactForm" */ 'Feature/LotteryContactForm/code/Scripts/contactForm');

if (ifExist('.gk-contact-form')) import(/* webpackChunkName: "gkContactForm" */ 'Feature/LotteryGkContactForm/code/Scripts/gkContactForm');

if (ifExist('.customer-data-form')) import(/* webpackChunkName: "changeCustomerData" */ 'Feature/LotteryChangeCustomerData/code/Scripts/ChangeCustomerData/changeCustomerData');

if (ifExist('.card-designer')) import(/* webpackChunkName: "cardDesigner" */ 'Feature/Shop/code/Scripts/CardDesigner/cardDesigner');

if (ifExist('.shop-age-verification')) import(/* webpackChunkName: "ageVerification" */ 'Feature/Shop/code/Scripts/AgeVerification/ageVerification');

if (ifExist('.shop-survey')) import(/* webpackChunkName: "survey" */ 'Feature/Shop/code/Scripts/Survey/survey');

if (ifExist('.shop-gk-checkout-info')) import(/* webpackChunkName: "gkCheckoutInfoModal" */ 'Feature/Shop/code/Scripts/GKCheckoutInfoModal/gkCheckoutInfoModal');

if (ifExist('.newsletter')) import(/* webpackChunkName: "newsletter" */ 'Feature/Shop/code/Scripts/Newsletter/newsletter');

if (ifExist('.annuallotextension')) import(/* webpackChunkName: "annualLotExtension" */ 'Feature/LotteryAnnualLotExtension/code/Scripts/AnnualLotExtension/annualLotExtension');

if (ifExist('.annuallotextension')) import(/* webpackChunkName: "annualLotExtensionModal" */ 'Feature/LotteryAnnualLotExtension/code/Scripts/AnnualLotExtension/annualLotExtensionModal');

if (ifExist('.lotteryticket-activation')) import(/* webpackChunkName: "lotteryTicketActivation" */ 'Feature/LotteryTicketActivation/code/Scripts/LotteryTicketActivation/lotteryTicketActivation');

if (ifExist('.annuallotextension__upselling')) import(/* webpackChunkName: "annualLotExtensionVue" */ 'Feature/LotteryAnnualLotExtension/code/Scripts/AnnualLotExtension/annualLotExtensionVue');

if (ifExist('.change-winningcategory, .change-winningcategory__form-section')) import(/* webpackChunkName: "changeWinningCategory" */ 'Feature/ChangeWinningCategory/code/Scripts/changeWinningCategory');

if (ifExist('.lotteryticket-explanation-slider, .lotteryticket-tiles, .lottery-participationcheck')) import(/* webpackChunkName: "lotteryTicketSlider" */ 'Feature/LotteryContentElements/code/Scripts/LotteryTicket/lotteryTicketSlider');

if (ifExist('.lottery-servicehub__container, .lottery-servicehub__tile')) import(/* webpackChunkName: "LotteryServiceHub" */ 'Feature/LotteryContentElements/code/Scripts/LotteryServiceHub/LotteryServiceHub');

if (ifExist('.lottery__form-field')) import(/* webpackChunkName: "ticket" */ 'Foundation/Common/code/Scripts/Ticket/ticket');

if (ifExist('.specialraffle__tile, .specialraffle')) import(/* webpackChunkName: "specialRaffleLotNumberTile" */ 'Feature/LotteryContentElements/code/Scripts/SpecialRaffle/specialRaffleLotNumberTile');

if (ifExist('.lottery-winning-chances__stage')) import(/* webpackChunkName: "winningChancesStage" */ 'Feature/LotteryContentElements/code/Scripts/LotteryWinningChances/winningChancesStage');

if (ifExist('.customer-profile-form, .customer-profile-error, .profile-dashboard, .detail-wrapper, .order-list')) import(/* webpackChunkName: "customerProfile" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerProfile');

if (ifExist('.lot-designs')) import(/* webpackChunkName: "customerDesigns" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerDesigns');

if (ifExist('.customer-profile-error')) import(/* webpackChunkName: "customerError" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerError');

if (ifExist('.password-reset__form')) import(/* webpackChunkName: "passwordReset" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/passwordReset');

if (ifExist('.lottery-early-bird__promo-code-module')) import(/* webpackChunkName: "promoCodeModule" */ 'Feature/LotteryEarlyBird/code/Scripts/LotteryEarlyBird/promoCodeModule');

if (ifExist('#CustomerRegistrationForm')) import(/* webpackChunkName: "customerRegistration" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerRegistration');

if (ifExist('#CustomerLoginForm')) import(/* webpackChunkName: "customerLogin" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerLogin');

if (ifExist('#CustomerProfileOrderOverview')) import(/* webpackChunkName: "customerOrderOverview" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerOrderOverview');

if (ifExist('#CustomerOrderDetailApp')) import(/* webpackChunkName: "customerOrderDetails" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerOrderDetails');

if (ifExist('#CustomerProfileDashboard')) import(/* webpackChunkName: "customerProfileDashboard" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerProfileDashboard');

if (ifExist('#CustomerProfileLoginDetailsForm')) import(/* webpackChunkName: "customerLoginDetails" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerLoginDetails');

if (ifExist('#downloadICS')) import(/* webpackChunkName: "iCalButtonBase" */ 'Foundation/ContentElements/code/Scripts/ICalButtonBase/iCalButtonBase');

if (ifExist('#downloadICSMultipleEvents')) import(/* webpackChunkName: "iCalButtonBaseMultipleEvents" */ 'Foundation/ContentElements/code/Scripts/ICalButtonBase/iCalButtonBaseMultipleEvents');

if (ifExist('#CustomerProfileTicketDetailsPage')) import(/* webpackChunkName: "customerTicketDetails" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerTicketDetails');

if (ifExist('#CustomerProfileTicketsOverviewPage')) import(/* webpackChunkName: "customerTicketsOverview" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerTicketsOverview');

if (ifExist('#CustomerTicketItem')) import(/* webpackChunkName: "customerTicket" */ 'Feature/CustomerProfile/code/Scripts/CustomerProfile/customerTicket')
